import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

import { sortActivities } from '@/modules/Activities'

export const useFetchAll = () => {
  const client = useGyymClient()
  const { data, ...rest } = useGyymSWR(client.user.top.fetchAll)

  if (!data) return { data, ...rest }

  const {
    data: {
      campaignFacilities,
      recommendedFacilities,
      activities: baseActivities,
      ...otherData
    },
  } = data

  // Sort activities
  const sortedData = {
    ...otherData,
    activities: sortActivities(baseActivities),
    campaignFacilities: campaignFacilities.map(
      ({ activities, ...facility }) => ({
        ...facility,
        // 施設のアクティビティをを並べ替える
        activities: sortActivities(activities),
      }),
    ),
    recommendedFacilities: recommendedFacilities.map(
      ({ activities, ...facility }) => ({
        ...facility,
        // 施設のアクティビティをを並べ替える
        activities: sortActivities(activities),
      }),
    ),
  }

  return {
    data: sortedData,
    ...rest,
  }
}

export type FetchAllData = ReturnType<typeof useFetchAll>['data']
